// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__assetSelect {
  display: flex;
  width: 100%;
  margin-bottom: '10px';
}

.app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__item {
  position: relative;
  margin: 2px;
  background-color: #555;
  color: #fff;
  padding: 3px 7px;
  border-radius: 3px;
  display: flex;
  align-items: center;
}

.app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__assetSelect > div {
  width: 100%;
}

.app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__assets {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./app/containers/Assets/AssetsSelectMultiple/AssetsSelectMultiple.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.assetSelect {\n  display: flex;\n  width: 100%;\n  margin-bottom: '10px';\n}\n\n.item {\n  position: relative;\n  margin: 2px;\n  background-color: #555;\n  color: #fff;\n  padding: 3px 7px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n}\n\n.assetSelect > div {\n  width: 100%;\n}\n\n.assets {\n  display: flex;\n  flex-wrap: wrap;\n  padding-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__container`,
	"assetSelect": `app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__assetSelect`,
	"item": `app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__item`,
	"assets": `app-containers-Assets-AssetsSelectMultiple-___AssetsSelectMultiple-module__assets`
};
export default ___CSS_LOADER_EXPORT___;
